import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "./chunk-OERUTHPZ.js";
import {
  Button
} from "./chunk-QXEA2YZ6.js";
import {
  Icon
} from "./chunk-7IEFGXFA.js";

// src/WorkspaceControls.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var WORKSPACE_MODES = {
  chat: { label: "Chat", icon: "message-square" },
  board: { label: "Board", icon: "panels-top-left" },
  flow: { label: "Flow", icon: "workflow" }
};
function WorkspaceModeControl({ mode: current, onModeChange, modes: available = ["board", "flow"], compact = false, toolbar = false }) {
  const modes = available.map((mode) => ({ ...WORKSPACE_MODES[mode], active: mode === current, onClick: () => onModeChange(mode) }));
  if (toolbar) return /* @__PURE__ */ jsx(TooltipProvider, { children: /* @__PURE__ */ jsx("div", { role: "group", "aria-label": "Canvas mode", className: "flex items-center gap-0.5 rounded-lg bg-muted p-0.5", children: modes.map((mode) => /* @__PURE__ */ jsxs(Tooltip, { children: [
    /* @__PURE__ */ jsx(TooltipTrigger, { asChild: true, children: /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        "aria-label": mode.label,
        "aria-pressed": mode.active,
        onClick: mode.onClick,
        className: `flex h-6 w-8 items-center justify-center rounded-md transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${mode.active ? "bg-background text-blue-600 shadow-sm dark:text-blue-400" : "text-muted-foreground hover:text-foreground"}`,
        children: /* @__PURE__ */ jsx(Icon, { name: mode.icon, className: "h-3.5 w-3.5" })
      }
    ) }),
    /* @__PURE__ */ jsxs(TooltipContent, { side: "bottom", size: "sm", children: [
      mode.label,
      " mode"
    ] })
  ] }, mode.label)) }) });
  return /* @__PURE__ */ jsx(TooltipProvider, { children: /* @__PURE__ */ jsx("div", { role: "group", "aria-label": "Canvas mode", className: "flex items-center gap-0.5", children: modes.map((mode) => /* @__PURE__ */ jsxs(Tooltip, { children: [
    /* @__PURE__ */ jsx(TooltipTrigger, { asChild: true, children: /* @__PURE__ */ jsx(Button, { type: "button", size: "icon", variant: mode.active ? "secondary" : "ghost", "aria-label": mode.label, "aria-pressed": mode.active, onClick: mode.onClick, className: compact ? "h-5 w-5 rounded" : "h-10 w-10 rounded-lg", children: /* @__PURE__ */ jsx(Icon, { name: mode.icon, className: compact ? "size-3" : "h-5 w-5" }) }) }),
    /* @__PURE__ */ jsxs(TooltipContent, { side: "top", size: "sm", children: [
      mode.label,
      " mode"
    ] })
  ] }, mode.label)) }) });
}
function WorkspacePanelControls({ panels }) {
  return /* @__PURE__ */ jsx(TooltipProvider, { children: /* @__PURE__ */ jsx("div", { role: "group", "aria-label": "Workspace panels", className: "flex items-center gap-0.5", children: panels.map((panel) => /* @__PURE__ */ jsxs(Tooltip, { children: [
    /* @__PURE__ */ jsx(TooltipTrigger, { asChild: true, children: /* @__PURE__ */ jsxs(Button, { type: "button", size: "icon-sm", variant: panel.open ? "secondary" : "ghost", "aria-label": panel.label, "aria-pressed": panel.open, onClick: panel.onClick, className: "relative rounded-md", children: [
      /* @__PURE__ */ jsx(Icon, { name: panel.icon, className: "h-3.5 w-3.5" }),
      panel.status && /* @__PURE__ */ jsx("span", { className: `absolute right-1 top-1 size-1.5 rounded-full ${panel.status === "error" ? "bg-destructive" : "bg-primary motion-safe:animate-pulse"}`, children: /* @__PURE__ */ jsx("span", { className: "sr-only", children: panel.status === "error" ? "Activity has errors" : "Work in progress" }) })
    ] }) }),
    /* @__PURE__ */ jsxs(TooltipContent, { side: "bottom", size: "sm", children: [
      panel.open ? "Hide" : "Show",
      " ",
      panel.label
    ] })
  ] }, panel.label)) }) });
}

export {
  WorkspaceModeControl,
  WorkspacePanelControls
};
//# sourceMappingURL=chunk-4AMTKXBX.js.map